<template>
  <v-card elevation="0" :color="showForm ? '#f4f4f4' : '#ffffff'" :class="type == 'selectToPackage' ? '' : 'px-4'">
    <v-divider></v-divider>

    <div class="d-flex justify-space-between mt-6" v-if="!showForm">
      <v-text-field style="max-width: 400px" v-model="search" append-icon="mdi-magnify" outlined
        :label="$t('products.ASUS.search')" single-line dense hide-details></v-text-field>

      <div class="d-flex" v-if="type !== 'selectToPackage'">
        <v-btn @click="addAsu()" class="py-5 ml-2 mb-1" color="success" elevation="0">{{
          $t("common.add")
        }}</v-btn>
        <!-- <v-alert dense outlined text max-width="500" type="warning" class="caption ml-2">{{
          $t("products.packages.inactiveFunction") }}</v-alert> -->
      </div>
    </div>
    <div>
    </div>
    <v-card outlined v-if="!showForm">
      <v-data-table :dense="type == 'selectToPackage'" :class="type == 'selectToPackage' ? 'dense-table' : ''"
        :headers="headers" :items="documents" :items-per-page="type == 'selectToPackage' ? 5 : 10" :search="search"
        :sort-by="sortBy" :sort-desc="sortDesc">
        <template v-if="type == 'selectToPackage'" v-slot:[`item.selected`]="{ item }">
          <v-checkbox v-model="item.selected"></v-checkbox>
        </template>
        <template v-slot:[`item.files`]="{ item }">
          <v-avatar size="38">
            <v-img width="38" height="38" :src="item.files[0]"></v-img>
          </v-avatar>
        </template>
        <template v-slot:[`item.sku`]="{ item }">
          <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" class="mx-4" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-information-variant </v-icon>
              </v-btn>
            </template>
            <v-card class="pa-2">
              <strong>{{ item.sku }}</strong>
              <p class="text-caption">
                ASU = <strong>A</strong>d <strong>S</strong>tock
                <strong>U</strong>nit
              </p>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:[`item.computed.formatText`]="{ item }">
          {{ item._format }} -
          <span class="mr-2" v-for="(bucket, bucketIndex) in item.buckets" :key="bucketIndex"><strong class="mr-1">{{
            bucket.title }}:</strong> {{
                bucket.name }}</span>
        </template>
        <template v-slot:[`item.rules.pricing.price`]="{ item }">
          <span class="mx-4">{{
            $n(item.rules.pricing.price, "currency")
          }}</span>
        </template>
        <template v-slot:[`item.createdOn`]="{ item }">
          {{ item.createdOn | dateTime }}
        </template>
        <template v-slot:[`item.computed.locationsText`]="{ item }">
          <span v-html="item.computed.locationsText"></span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip label small class="mx-2" v-if="item.status" color="success">{{
            $t("products.ASUS.asuList.active")
          }}</v-chip>
          <v-chip label small class="mx-2" v-else>{{
            $t("products.ASUS.asuList.inactive")
          }}</v-chip>
        </template>
        <!-- <template v-slot:[`item.buckets`]="{ item }">
          {{ setBuckets(item.buckets) }}
        </template> -->
        <template v-slot:[`item.duration`]="{ item }">
          <v-text-field @input="toUpdate()" @blur="toUpdate()" step="1" type="number" v-model="item.duration"
            :disabled="!item.selected" :min="item.rules.periods.min" :max="item.rules.periods.max">

          </v-text-field>
        </template>
        <template v-slot:[`item.insertions`]="{ item }">
          <v-text-field @input="toUpdate()" @blur="toUpdate()" type="number" v-model="item.insertions"
            :disabled="!item.selected" :error-messages="fillErrors[item.sku]" :min="item.rules.insertions.min *
              (calcTotalDaysPeriod(item)
                ? calcTotalDaysPeriod(item)
                : item.rules.periods.min)
              " :max="item.rules.insertions.max
                ? item.rules.insertions.max *
                (calcTotalDaysPeriod(item)
                  ? calcTotalDaysPeriod(item)
                  : item.rules.periods.max)
                : ''
                " :step="calcTotalDaysPeriod(item) ? calcTotalDaysPeriod(item) : 1">
            <v-menu slot="append" left offset-y class="d-flex">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon x-small color="primary" v-bind="attrs" v-on="on"><v-icon
                    small>mdi-information-variant</v-icon></v-btn>
              </template>
              <v-card max-width="480" class="ma-0">
                <v-alert class="mb-0" text color="info" dense v-if="errorPackSum(item)">
                  Nesta Regra de Preenchimento, as inserções devem ser múltiplas de
                  {{ calcTotalDaysPeriod(item) ? calcTotalDaysPeriod(item) : 1 }}
                  , minimo de
                  {{
                    item.rules.insertions.min *
                    (calcTotalDaysPeriod(item) ? calcTotalDaysPeriod(item) : 1)
                  }}
                  <template v-if="item.rules.insertions.max">
                    e com maximo de
                    {{
                      item.rules.insertions.max *
                      (calcTotalDaysPeriod(item)
                        ? calcTotalDaysPeriod(item)
                        : item.rules.periods.max)
                    }}
                  </template>
                </v-alert>
              </v-card>
            </v-menu>
          </v-text-field>
        </template>
        <template v-slot:[`item.preview`]="{ item }">
          <div class="d-flex">
            <!-- <v-btn icon @click="assoc(item)"><v-avatar size="18"><v-img
                  src="https://lion-web-site.s3.amazonaws.com/public/google-ad-manager-logo.svg"
                  width="18px"></v-img></v-avatar></v-btn> -->
            <v-btn class="ml-1" icon :href="`https://${item.store}.themediatrade.com/product/${item.id}`"
              target="_blank"><v-icon small>mdi-open-in-new</v-icon></v-btn>
            <v-btn class="ml-1" icon @click="duplicate(item)">
              <v-icon small>
                mdi-content-duplicate
              </v-icon>
            </v-btn>
            <v-btn class="ml-1" icon @click="deleteItem(item)">
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
            <v-btn class="ml-1" icon @click="openAsu(item)" color="primary"><v-icon small>mdi-pencil</v-icon></v-btn>
          </div>
        </template>
      </v-data-table>
      <!-- <v-dialog v-model="showAssoc" width="640">
        <v-card class="mx-auto">
          <v-card-title>Asociación de producto con AdUnit (Google AdManager)</v-card-title>
          <v-card-text v-if="association.product">
            <v-text-field :value="`${association.product.computed.formatText} - ${association.product.computed.coverage} (SKU: ${association.product.sku})`" readonly label="Producto"></v-text-field>
            <v-autocomplete v-model="association.adUnitId" :disabled="association.loading" :items="association.adUnit.list"
              item-value="id" item-text="label" label="AdUnit" :filter="association.search"></v-autocomplete>
            <div class="d-flex pt-1">
              <v-spacer></v-spacer>
              <v-btn class="mr-1" text @click="closeAssoc()">Cancelar</v-btn>
              <v-btn color="success" elevation="0" @click="saveAssoc()">Gravar</v-btn>
            </div>
          </v-card-text>
  
        </v-card>
      </v-dialog> -->



      <!-- <v-dialog persistent fullscreen hide-overlay v-model="showForm">
        <AsusForm :asu="asu" :editing="editing" :stores="allStores"></AsusForm>
      </v-dialog> -->
    </v-card>
    <template v-if="showForm">
      <AsusForm v-if="showForm" :asu="asu" :editing="editing" :stores="allStores" @close-form="closeForm()"
        @update-asu="updateAsu($event)"></AsusForm>
    </template>

  </v-card>
</template>
<script>
import config from "@/store/config";
import moment from "moment";
import { mapActions } from "vuex";
import { mapState } from "vuex";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  setDoc,
  doc,
  getDocs
} from "firebase/firestore";
import AsusForm from "./AsusForm.vue";
export default {
  name: "AsusList",
  components: {
    AsusForm
  },
  data() {
    return {
      asu: {},
      editing: false,
      showForm: false,
      showAssoc: false,
      association: {
        product: null,
        adUnitId: null,
        adUnit: {
          list: [],
          loading: false
        },
      },
      updated: 0,
      loading: true,
      search: this.$route.query.q ? this.$route.query.q : "",

      documents: [],
    };
  },
  props: {
    rangeStart: [null, String],
    rangeEnd: [null, String],
    isDynamic: {
      type: Boolean,
      required: false
    },
    totalDays: {
      required: false,
      type: [Number, null],
    },
    type: {
      required: false,
      type: String,
    },
    rule: {
      required: false,
      type: String,
    },
    snap: {
      required: false,
      type: Array,
    },
    sortBy: {
      type: Array,
      default: undefined,
    },
    sortDesc: {
      type: Array,
      default: undefined,
    },
    selectedOrdenate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("groupStores", [
      "masterStore", "allStores"]
    ),
    fillErrors() {
      let allErrorsCount = 0
      const u = this.updated
      const asus = {}
      if (u > -1 && this.snap) {
        console.log('#2')
        this.snap.forEach((item) => {
          asus[item.sku] = []
          if (!item.insertions) {
            asus[item.sku].push('Inserciones es obligatorio');
            allErrorsCount++
          }
          if (this.rule == 'dynamic' && !item.duration) {
            asus[item.sku].push('Duracion es obligatorio')
            allErrorsCount++
          }
          if (item.insertions < item.duration) {
            asus[item.sku].push(`Inserciones debe ser igual o mayor que ${item.duration}`);
            allErrorsCount++
          }
          if (item.insertions % item.duration != 0) {
            asus[item.sku].push(`Inserciones deve ser multiplo de ${item.duration}`)
            allErrorsCount++
          }
        })
      }
      asus.a = allErrorsCount
      return asus
    },
    headers() {
      return [
        {
          text: "",
          align: "start",
          sortable: true,
          value: "files",
        },
        {
          text: this.$t("products.ASUS.asuList.asuTitle"),
          value: "sku",
          align: "center",
        },
        {
          text: this.$t("products.ASUS.asuList.formatTitle"),
          value: "computed.formatText",
        },
        {
          text: this.$t("products.ASUS.asuList.finalPrice"),
          value: "rules.pricing.price",
        },
        // {
        //   text: this.$t("products.ASUS.asuList.locations"),
        //   value: "computed.locationsText",
        // },
        {
          text: this.$t("products.ASUS.asuList.coverage"),
          value: "_coverage",
        },

        {
          text: this.$t("products.ASUS.asuList.status"),
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: this.$t("products.ASUS.asuList.stores"),
          align: "start",
          sortable: true,
          value: "store",
        },
        // {
        //   text: this.$t("products.ASUS.asuList.buckets"),
        //   align: "start",
        //   sortable: true,
        //   value: "buckets",
        // },

        {
          text: "Código interno",
          align: "start",
          sortable: true,
          value: "internalCode",
        },
        {
          text: this.$t("products.ASUS.asuList.createAd"),
          align: "start",
          sortable: true,
          value: "createdOn",
        },
        {
          text: this.$t("products.ASUS.asuList.duration"),
          align: "start",
          sortable: true,
          value: "duration",
        },
        {
          text: this.$t("products.ASUS.asuList.inserts"),
          align: "start",
          sortable: true,
          value: "insertions",
        },


        {
          text: '',
          align: "end",
          sortable: false,
          value: "preview"
        }
      ];
    },

    selection() {
      if (this.type == "selectToPackage") {
        const list = this.documents.filter((asu) => {
          return asu.selected;
        });
        return list;
      }
      return [];
    },
  },
  created() {
    if (this.type && this.type == "selectToPackage") {
      this.headers.unshift({ text: "", value: "selected" });
    } else {
      this.headers.splice(this.headers.length - 3, 2);
    }
  },
  mounted() {
    this.loadDocuments();
    if (this.masterStore.integrations && this.masterStore.integrations.googleAdManager && this.masterStore.integrations.googleAdManager.enabled) {

      this.loadAdUnits()
    }

  },
  watch: {
    'fillErrors.a': {
      deep: true,
      handler(v) {
        this.$emit('has-error', v > 0)
      }
    },
    "$route.fullPath": {
      deep: true,
      handler() {
        this.loadPath()
      }
    },
    "$route": {
      deep: true,
      handler(v) {
        if (v.query.action && v.query.id) {
          console.log('C', v)

        }
        else {
          this.showForm = false
        }
      }
    },
    "$route.params.tab"(value) {
      if (value != 1)
        this.search = this.$route.query.q ? this.$route.query.q : "";
    },
    selection: {
      deep: true,
      handler(value) {
        console.log("emiting selection ", value);
        this.$emit("change-asus", value);
      },
    },
    totalDays: {
      deep: true,
      handler(val) {
        let prevent = JSON.parse(JSON.stringify({
          v: val
        }))
        console.log('#3')
        this.documents.forEach((doc) => {
          doc.insertions = doc.rules.insertions.min * (val ? val : 1);
          doc.duration = prevent.v

        });
      },
    },
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    closeAssoc() {
      console.log('closing assoc')
      this.showAssoc = false
    },
    updateAsu(e) {
      const id = e.id
      const i = this.documents.findIndex(d => d.id == id)
      const asu = JSON.parse(JSON.stringify(e))
      this.documents[i] = asu
      this.$router.push("/products/asus")
      this.editing = false
      this.showForm = false
    },
    openAsu(item) {
      if(!item.hasOwnProperty('specificationTypes'))
        item.specificationTypes = []
      this.asu = item
      this.editing = true
      this.showForm = true
    },
    loadPath() {
      const v = this.$route
      if (v.query.hasOwnProperty("action")) {
        setTimeout(() =>{
          if (v.query.action == 'new')
            this.showForm = true
        },100)
      }
    },
    addAsu() {
      this.asu = null
      this.editing = false
      this.showForm = true
    },
    saveAssoc() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);

      const asu = this.association.product
      asu.createdOn = moment().format()
      asu.adUnitId = this.association.adUnitId
      setDoc(doc(db, "asus", asu.id), asu)
        .then(() => {
          this.processing = false;
          this.showSnack({
            text: 'AdUnit se ha asociado correctamente con el producto.',
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
        })
        .then(() => {

        })

    },
    objectId() {
      var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
      return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
        return (Math.random() * 16 | 0).toString(16);
      }).toLowerCase();
    },
    duplicate(item) {
      const firebase = initializeApp(config);

      const Form = JSON.parse(JSON.stringify(item))
      Form.copyFrom = item.id
      Form.createdOn = moment().format()
      Form.updatedOn = moment().format()
      Form.sku = this.objectId()
      Form.audience.value = parseFloat(Form.audience.value)
      Form.publicProfile.ageGroup.forEach((p) => {
        p.percent = parseFloat(p.percent)
      })
      Form.publicProfile.gender.male = parseFloat(Form.publicProfile.gender.male)
      Form.publicProfile.gender.female = parseFloat(Form.publicProfile.gender.female)

      Form.publicProfile.socialClass.forEach((p) => {
        p.percent = parseFloat(p.percent)
      })
      Form.rules.periodicity.value = Form.rules.periodicity.value && isNaN(Form.rules.periodicity.value) ? parseFloat(Form.rules.periodicity.value.replace(',', '.')) : Form.rules.periodicity.value
      Form.rules.periods.min = Form.rules.periods.min && isNaN(Form.rules.periods.min) ? parseFloat(Form.rules.periods.min.replace(',', '.')) : Form.rules.periods.min
      Form.rules.periods.max = Form.rules.periods.max && isNaN(Form.rules.periods.max) ? parseFloat(Form.rules.periods.max.replace(',', '.')) : Form.rules.periods.max
      Form.rules.quantity.min = Form.rules.quantity.min && isNaN(Form.rules.quantity.min) ? parseFloat(Form.rules.quantity.min.replace(',', '.')) : Form.rules.quantity.min
      Form.rules.quantity.max = Form.rules.quantity.max && isNaN(Form.rules.quantity.max) ? parseFloat(Form.rules.quantity.max.replace(',', '.')) : Form.rules.quantity.max
      Form.rules.reservation.min = Form.rules.reservation.min && isNaN(Form.rules.reservation.min) ? parseFloat(Form.rules.reservation.min.replace(',', '.')) : Form.rules.reservation.min
      Form.rules.reservation.max = Form.rules.reservation.max && isNaN(Form.rules.reservation.max) ? parseFloat(Form.rules.reservation.max.replace(',', '.')) : Form.rules.reservation.max

      Form.rules.pricing.discount = Form.rules.pricing.discount && isNaN(Form.rules.pricing.discount) ? parseFloat(Form.rules.pricing.discount.replace(',', '.')) : Form.rules.pricing.discount
      Form.rules.pricing.tablePrice = Form.rules.pricing.tablePrice && isNaN(Form.rules.pricing.tablePrice) ? parseFloat(Form.rules.pricing.tablePrice.replace(',', '.')) : Form.rules.pricing.tablePrice
      Form.rules.pricing.unityPrice = Form.rules.pricing.unityPrice && isNaN(Form.rules.pricing.unityPrice) ? parseFloat(Form.rules.pricing.unityPrice.replace(',', '.')) : Form.rules.pricing.unityPrice
      Form.id = Form.sku
      const db = getFirestore(firebase);
      setDoc(doc(db, "asus", Form.sku), Form).then(() => {
        this.loadDocuments()
        this.openAsu(Form)
      });
    },


    closeForm() {
      this.$router.push("/products/asus")
      this.showForm = false
    },
    loadAdUnits() {
      this.association.loading = true
      let list = []
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({});

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };


      fetch("https://gam.themediatrade.com/api/v1/gam/adunit/list", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const res = JSON.parse(result)
          console.log('#4')
          res.data.forEach((item) => {
            if (item.status == 'ACTIVE')
              list.push({ ...item, 'label': `${item.name} (${item.id})` })
          })
          this.association.adUnit.list = list
          this.association.loading = false
        })
        .catch(() => {
          this.association.loading = false
        });
    },
    assoc(item) {
      this.association.product = item
      this.showAssoc = true
    },
    toUpdate() {
      this.updated++
    },
    setBuckets(bucket) {
      let buckets = [];
      console.log('#5')
      bucket.forEach((item) => {
        buckets.push(`${item.title}: ${item.name}`);
      });
      return buckets.join(', ');
    },
    calcTotalDaysPeriod(item) {
      if (this.rule == "dynamic") {
        if (!item.duration) {
          item.duration = this.totalDays
        }
        return item.duration
      }
      if (!this.rangeStart || !this.rangeEnd || this.rule != "close") {
        return this.totalDays;
      } else {
        const rules = item.rules.weekDays;
        let sum = 0;
        let count =
          moment(this.rangeEnd).diff(moment(this.rangeStart), "days") + 1;
        for (let i = 0; i < count; i++) {
          const wday = moment(this.rangeStart).add(i, "day").day();

          if (rules.includes(wday)) {
            sum++;
          }
        }
        item.duration = sum;
        return sum;
      }
    },
    errorPackSum(item) {
      if (!this.calcTotalDaysPeriod(item)) return false;
      if (
        item.insertions <
        item.rules.insertions.min *
        (this.calcTotalDaysPeriod(item) ? this.calcTotalDaysPeriod(item) : 1)
      )
        return true;
      if (
        item.insertions >
        item.rules.insertions.max *
        (this.calcTotalDaysPeriod(item)
          ? this.calcTotalDaysPeriod(item)
          : item.rules.periods.max)
      )
        return true;
      return !Number.isInteger(
        item.insertions / this.calcTotalDaysPeriod(item)
      );
    },
    loadDocuments() {
      const snap = {};
      if (this.type == "selectToPackage") {
        if (typeof this.snap != "undefined" && this.snap && this.snap.length) {
          console.log('#7')
          this.snap.forEach((asu) => {
            snap[asu.sku] = {
              insertions: asu.insertions,
              duration: asu.duration
            }
          });
        }
      }

      this.loading = true;
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "asus"));
      const querySnapshot = getDocs(q);
      const documents = [];
      querySnapshot.then((docs) => {
        console.log('#8')
        docs.forEach((document) => {
          if (!this.$root.auth.profile.hasOwnProperty('whitelabelId') || !this.$root.auth.profile.whitelabelId || document.data().store == this.$root.auth.profile.whitelabelId) {

            if (
              (this.type == "selectToPackage" && document.data().status) ||
              this.type != "selectToPackage"
            ) {
              const format = document.data().format;
              // const formatParts = [];
              // console.log('#9')
              // format.print.split(" ").forEach((p) => {
              //   // /const kl = `format.${format[p]}`
              //   const ktv = this.$t(`format.${format[p]}`);
              //   const noPoint = !ktv.includes(".");
              //   //console.log('spli',  format.print.split(' '))
              //   // console.log('format[k]', ktv)
              //   // console.log('noPoint', noPoint)

              //   // console.log('format[te]', this.$te(kl))
              //   // console.log('format[t]', this.$t(kl))
              //   console.log('no point', noPoint)
              //   const el =
              //     p == "metric"
              //       ? noPoint
              //        ? format[p] :
              //         this.$t(`format.${format[p]}`)

              //       : format[p];
              //       console.log('E L:', el)
              //   formatParts.push(el);
              //   //console.log('el', el)
              // });
              // console.log('formatParts', formatParts)

              // discount
              console.log('format', format)
              const formatTxt = format.print.replace('value', format.value).replace('metric', format.metric).replace('type', format.type)
              // console.log('formatTxt', formatTxt)
              const discount =
                document.data().rules.pricing.unityPrice !=
                  document.data().rules.pricing.price
                  ? this.$n(
                    (1 -
                      document.data().rules.pricing.price /
                      document.data().rules.pricing.unityPrice) *
                    100
                  )
                  : null;

              // mediatype
              const mediaType = {
                value: document.data().mediaType.parents,
                text: this.$t(
                  `format.mediaTypes.${document.data().mediaType.parents}`
                ),
              };

              // location
              const locationsSnap = document.data().locations;
              const locationsSearch = {};
              // console.log('#1')
              locationsSnap.forEach((location) => {
                const key = `${location.city} - ${location.state} - ${location.country}`;
                if (!locationsSearch.hasOwnProperty(key))
                  locationsSearch[key] = { key: key, ...location };
              });

              // time
              const dta = document.data();
              const time = dta.hasOwnProperty.hasOwnProperty("timeSlot")
                ? dta.timeSlot
                : { min: null, max: null };
              const timeSlot = [];
              let timeText = null;
              if (time.min !== null)
                timeSlot.push(moment(time.min, "X").format("LT"));
              else timeSlot.push("-");

              if (time.max !== null)
                timeSlot.push(moment(time.max, "X").format("LT"));
              else timeSlot.push("-");

              if (timeSlot[0] != "-" && timeSlot[1] != "-")
                timeText = `${time.type} ${this.$tc(
                  "format.timeRange",
                  timeSlot[0],
                  { from: timeSlot[0], to: timeSlot[1] }
                )}`;
              if (timeSlot[0] != "-" && timeSlot[1] == "-")
                timeText = `${time.type} ${this.$tc(
                  "format.timeFrom",
                  timeSlot[0],
                  { from: timeSlot[0] }
                )}`;
              if (timeSlot[0] == "-" && timeSlot[1] != "-")
                timeText = `${time.type} ${this.$tc(
                  "format.timeTo",
                  timeSlot[1],
                  { to: timeSlot[1] }
                )}`;

              // locations
              const locations = [];
              for (let i = 0; i < document.data().locations.length; i++) {
                if (i == 2) break;
                else locations.push(document.data().locations[i].city);
              }
              const more =
                document.data().locations.length > 3
                  ? `<strong>+ ${document.data().locations.length - 3
                  } cidades</strong>.`
                  : "";

              const docDataT = JSON.parse(JSON.stringify(document.data()));
              delete docDataT.interests;

              const data = {
                id: document.id,

                computed: {
                  coverage: document.data().coverage ? document.data().coverage.join(', ') : '',
                  formatText: formatTxt, // formatParts.join(" "),
                  discount: discount,
                  time: timeText,
                  mediaType: mediaType,
                  locationsText: ` ${locations.join(", ")} ${this.$tc(
                    "common.location",
                    document.data().locations.length - 2,
                    { count: document.data().locations.length - 2 }
                  )}`,
                  locationsSearch: locationsSearch,
                },
                interests: document
                  .data()
                  .interests.filter((item) => item !== ""),
                ...docDataT,
              };
              // console.log('Data comp', data.computed)
              if (this.type == "selectToPackage") {
                data.selected = snap.hasOwnProperty(data.sku);
                data.insertions = snap.hasOwnProperty(data.sku)
                  ? snap[data.sku].insertions
                  : data.rules.insertions.min *
                  (this.calcTotalDaysPeriod(data)
                    ? this.calcTotalDaysPeriod(data)
                    : data.rules.periods.min);
                data.duration = snap.hasOwnProperty(data.sku)
                  ? snap[data.sku].duration
                  : this.totalDays
              }
              console.log('data', data)
              documents.unshift(data);
            }
          }

        });

        if (this.selectedOrdenate) {
          const prioritySkus = this.snap.map(item => item.sku)
          console.log("skus", prioritySkus);
          const sortedArray = documents.sort((a, b) => {
            const aIsPriority = prioritySkus.includes(a.sku);
            const bIsPriority = prioritySkus.includes(b.sku);

            if (aIsPriority && !bIsPriority) {
              return -1;
            }

            if (!aIsPriority && bIsPriority) {
              return 1;
            }
            return 0;
          });
          console.log("sortedArray", sortedArray);
          console.log("doc", documents);

          this.documents = sortedArray;
          this.loading = false;

        } else {
          console.log("doc", documents)
          this.documents = documents;
          this.loading = false;
        }
        this.loadPath()

      });
    },
  },
};
</script>

<style lang="scss">
.dense-table {

  th,
  td {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>